import type { CurriculumTierId } from '../types';

/** Progression A/B/C feature toggles. */
export const PROGRESSION = {
  paletteCleansers: true,
  trinProof: true,
  miniCheckpoints: true,
  requireTrinProof: true,
  requireMiniCheckpoint: false,
  /** Tiers where typed case must match target text. */
  strictCaseFromTier: 'niveau-5' as CurriculumTierId,
} as const;
